var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef, EventEmitter } from '@angular/core';
import { ScaleResult } from '../../shared/models/scale-result';
import { ChartService } from "../services/chart.service";
import { ScaleResultColorService } from 'app/assessment-charts/services/scale-result-color.service';
import { BaseChartComponent } from 'app/assessment-charts/base-chart/base-chart.component';
import * as Chart from 'chart.js';
var ScaleChartComponent = /** @class */ (function (_super) {
    __extends(ScaleChartComponent, _super);
    function ScaleChartComponent(el, chartService, scaleResultColorService) {
        var _this = _super.call(this, el, chartService) || this;
        _this.el = el;
        _this.chartService = chartService;
        _this.scaleResultColorService = scaleResultColorService;
        _this.complete = new EventEmitter();
        return _this;
    }
    ScaleChartComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    ScaleChartComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    ScaleChartComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ScaleChartComponent.prototype.handleChartAnimationComplete = function (e) {
        var chartInstance = this.getChart(), ctx = chartInstance.ctx;
        ctx.font = Chart.helpers.fontString('16px', 700, Chart.defaults.global.defaultFontFamily);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        chartInstance.data.datasets.forEach(function (dataset, i) {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
                var data = dataset.data[index];
                ctx.fillText(data, bar._model.x, bar._model.y - 5);
            });
        });
        this.complete.emit(e);
    };
    ScaleChartComponent.prototype.setupChartData = function () {
        var barColor = "rgba(92,141,181, .75)";
        var hoverBackgroundColor = "rgba(92,141,181, .75)";
        if (this.scaleResult) {
            var name_1 = this.scaleResult.scale ? this.scaleResult.scale.name : "Score";
            var score = this.scaleResult.score ? this.scaleResult.score : 0;
            this._barData = [{ data: [score], label: "Your Score", yAxisID: 'y-axis-0', xAxisID: 'x-axis-0',
                    hoverBackgroundColor: hoverBackgroundColor, backgroundColor: barColor }];
        }
        else {
            this._barData = [{ data: [], label: "Your Score", hoverBackgroundColor: hoverBackgroundColor, backgroundColor: barColor }];
        }
        // if (this.scaleResult) {
        //   this._labelData = [this.scaleResult.scale ? name : "Your Score"];
        // }
        // else {
        this._labelData = ["Your Score"];
        // }
        // if (!this.showScaleName) {
        //   this._labelData = [""];
        // }
    };
    ScaleChartComponent.prototype.getLabelData = function () {
        return this._labelData;
    };
    ScaleChartComponent.prototype.getDatasets = function () {
        return this._barData;
    };
    ScaleChartComponent.prototype.getMaxYAxisTick = function () {
        var range = this.scaleResult.scale.getMaxRange();
        return range ? range.rangeEnd : 1;
    };
    ScaleChartComponent.prototype.setupChartConfiguration = function () {
        var configuration = _super.prototype.setupChartConfiguration.call(this);
        configuration.title = {
            // display: this.showScaleName
            text: this.scaleResult.scale.name
        };
        configuration.scales.xAxes[0].display = true; //this.showScaleName;
        configuration.scales.xAxes[0].barPercentage = 0.25;
        configuration.scales.xAxes[0].padding = 0;
        configuration.scales.xAxes[0].ticks.display = false;
        configuration.scales.xAxes[0].scaleLabel.fontSize = parseFloat(this.getComputedProperty('font-size', 12)); // get the float value
        configuration.scales.xAxes[0].scaleLabel.display = true;
        configuration.scales.xAxes[0].scaleLabel.labelString = "YOUR SCORE";
        configuration.scales.xAxes[0].scaleLabel.fontStyle = this.getComputedProperty('font-style', 'normal');
        configuration.scales.xAxes[0].scaleLabel.fontFamily = this.getComputedProperty('font-family', "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif");
        // configuration.scales.xAxes[0].scaleLabel.fontWeight = this.getComputedProperty('font-weight', 400);
        configuration.scales.xAxes[0].scaleLabel.lineHeight = this.getComputedProperty('line-height', 1.2);
        configuration.scales.xAxes[0].scaleLabel.fontColor = this.getComputedProperty('color', '#666');
        configuration.scales.xAxes[0].gridLines.display = false;
        configuration.scales.yAxes[0].scaleLabel.display = true;
        configuration.scales.yAxes[0].ticks.padding = 0;
        configuration.annotation.annotations = this.setupAnnotations();
        configuration.legend.display = false;
        configuration.tooltips.enabled = false;
        return configuration;
    };
    ScaleChartComponent.prototype.getComputedProperty = function (property, defaultValue) {
        if (defaultValue === void 0) { defaultValue = ""; }
        var window = this.el.nativeElement.ownerDocument.defaultView || {};
        var value = null;
        if (window.getComputedStyle) {
            value = window.getComputedStyle(this.el.nativeElement).getPropertyValue(property) || null;
        }
        if (value === null) {
            value = defaultValue;
        }
        return value;
    };
    ScaleChartComponent.prototype.setupAnnotations = function () {
        var annotations = [];
        if (this.showRanges && this.scaleResult && this.scaleResult.scale) {
            var even_1 = false;
            this.scaleResult.scale.ranges.forEach(function (r) {
                even_1 = !even_1;
                var line = {
                    drawTime: 'afterDraw',
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: r.midPoint,
                    borderColor: "rgba(0,0,0,0)",
                    borderWidth: 0,
                    label: {
                        backgroundColor: "rgba(0,0,0,0)",
                        fontColor: "black",
                        position: "left",
                        yAdjust: 10,
                        content: r.displayName,
                        enabled: true
                    },
                };
                annotations.push(line);
                if (even_1) {
                    var box = {
                        drawTime: "beforeDatasetsDraw",
                        type: "box",
                        yScaleID: "y-axis-0",
                        yMin: r.rangeStart,
                        yMax: r.rangeEnd,
                        backgroundColor: (even_1) ? "rgba(68, 170, 213, 0.1)" : "rgba(0,0,0,0)",
                        borderColor: "rgb(0, 0, 0, 0)",
                        borderWidth: 0
                    };
                    annotations.push(box);
                }
            });
        }
        return annotations;
    };
    Object.defineProperty(ScaleChartComponent.prototype, "hasResult", {
        get: function () {
            return this.scaleResult != null;
        },
        enumerable: true,
        configurable: true
    });
    return ScaleChartComponent;
}(BaseChartComponent));
export { ScaleChartComponent };



// WEBPACK FOOTER //
// ./src/app/assessment-charts/scale-chart/scale-chart.component.ts.pre-build-optimizer.js